export default __webpack_public_path__ + "static/media/202.2bb052e5.jpg";